import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnLinkChange = () => {
  const location = useLocation();
  // console.log(location)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
};

export default ScrollToTopOnLinkChange;